const fr = {
  // Navbar
  nav: {
    generate: "Générer",
  },
  // Sidebar
  sidebar: {
    dashboard: "Tableau de bord",
    generate: "Générer",
    history: "Historique",
    templates: "Templates",
    account: "Compte",
    profile: "Profil & voix",
    billing: "Facturation",
    credits: "Crédits",
    renewsOn: "Renouvelle {{date}}",
    voice: "Voix",
    favorites: "Favoris",
    settings: "Paramètres",
    logout: "Se déconnecter",
    expand: "Déplier le menu",
    collapse: "Replier le menu",
  },
  // Dashboard
  dashboard: {
    eyebrow: "Tableau de bord",
    greeting: "Bonjour {{name}}.",
    tagline: "On crée quoi ?",
    historyBtn: "Historique",
    newContent: "Nouveau contenu",
    emptyTitle: "Bienvenue sur CONTENT.IQ !",
    emptyDesc: "Générez votre premier contenu pour voir vos statistiques.",
    emptyBtn: "Générer mon premier contenu",
    creditsRemaining: "Crédits restants",
    renewsIn: "Renouvelle dans {{days}} jours",
    topUp: "Recharger",
    contentsThisMonth: "Contenus ce mois",
    thisMonth: "+{{n}} ce mois",
    tokensUsed: "Tokens consommés",
    totalCumul: "total cumulé",
    favorites: "Favoris",
    savedContents: "contenus sauvegardés",
    activityChart: "Activité — 30 jours",
    activityChartBase: "Activité",
    topTypes: "Types les plus utilisés",
    recentContents: "Derniers contenus",
    seeAll: "Tout voir →",
    noHistory: "Générez du contenu pour voir l'historique",
    overview: "Vue d'ensemble",
    totalCreated: "contenus créés au total",
    creditsUsedMonth: "crédits consommés ce mois",
    generateBtn: "Générer",
    noData: "Pas encore de données",
    today: "Auj.",
    period30d: "30j",
    period7d: "7j",
    periodYear: "an",
  },
  // Generate page
  generate: {
    title: "Nouveau contenu",
    briefHeader: "Brief de génération",
    dictate: "Dicter le brief",
    contentType: "Type de contenu",
    subject: "Sujet *",
    subjectPlaceholder: "Ex: Annonce de notre plan Business pour les agences africaines",
    tone: "Ton",
    length: "Longueur",
    language: "Langue",
    keywords: "Mots-clés à inclure",
    keywordPlaceholder: "+ ajouter…",
    audience: "Audience cible",
    audiencePlaceholder: "Ex: PME africaines, 30-50 ans",
    generateBtn: "Générer le contenu",
    generatingBtn: "Génération en cours…",
    stopBtn: "Arrêter",
    hint: "⌘ + ↵ ou dites « génère »",
    statusGenerating: "● Génération en cours",
    statusReady: "✓ Contenu prêt",
    statusConfigure: "Configurez et générez",
    tokens: "{{n}} tokens…",
    copy: "Copier",
    copied: "Copié !",
    regenerate: "Régénérer",
    exporting: "Export…",
    export: "Exporter",
    exportPdf: "PDF",
    exportDocx: "Word (.docx)",
    exportMarkdown: "Markdown",
    exportTxt: "Texte (.txt)",
    exportSuccess: "Export {{fmt}} prêt !",
    exportError: "Export échoué",
    exportErrorDesc: "Vérifiez votre plan ou réessayez.",
    briefDictated: "Brief dicté !",
    briefDictatedDesc: "Le sujet a été rempli automatiquement.",
    // Content types
    typeLinkedin: "LinkedIn",
    typeBlog: "Article",
    typeEmail: "Email",
    typeTwitter: "X / Thread",
    typeInstagram: "Instagram",
    typeProduct: "Produit",
    typeYoutube: "YouTube",
    typeBio: "Bio",
    // Tones
    toneProfessional: "Professionnel",
    toneCasual: "Décontracté",
    toneInspiring: "Inspirant",
    toneTechnical: "Technique",
    toneHumorous: "Humoristique",
    tonePersuasive: "Persuasif",
    // Lengths
    lengthShort: "Court · < 300 mots",
    lengthMedium: "Moyen · 300–800 mots",
    lengthLong: "Long · 800–2000 mots",
    // TTS
    ttsRead: "Lire",
    ttsStop: "Arrêter",
    // Translation
    translate: "Traduire EN",
    translating: "Traduction…",
    translateNeedSave: "Sauvegardez d'abord le contenu",
    translateDone: "Traduction prête !",
    translateError: "Erreur de traduction",
    translationTitle: "Traduction en anglais",
    // Toasts
    contentGenerated: "Contenu généré !",
    contentNotFound: "Contenu introuvable",
    genSaveError: "Erreur de sauvegarde",
    templateSaved: 'Template "{{name}}" enregistré',
    templateSaveError: "Erreur lors de l'enregistrement du template",
    streamingError: "Erreur de génération",
  },
  // Voice page
  voice: {
    pageTitle: "Assistant vocal",
    pageSubtitle: "Parlez pour naviguer, générer ou lire du contenu.",
    tapToSpeak: "Appuyez sur le micro pour parler",
    listening: "J'écoute… Parlez maintenant",
    processing: "Analyse en cours…",
    transcriptLabel: "Transcription",
    copyTranscript: "Copier",
    detectedCommand: "Commande détectée",
    commandsTitle: "Exemples de commandes",
    ttsActive: "Lecture en cours…",
    ttsStop: "Arrêter",
    exNav: "Tableau de bord",
    exNavDesc: "Navigate vers une page",
    exGenerate: "Génère un post LinkedIn sur l'IA",
    exGenerateDesc: "Ouvre la page de génération pré-remplie",
    exRead: "Lis le contenu",
    exReadDesc: "Lance la lecture TTS du contenu actuel",
    exTranslate: "Traduire en anglais",
    exTranslateDesc: "Lance la traduction du contenu",
    exExport: "Exporte en PDF",
    exExportDesc: "Lance l'export dans le format voulu",
    exHelp: "Aide",
    exHelpDesc: "Affiche la liste des commandes disponibles",
    assistantTitle: "IQ Vocal",
    assistantListen: "Je vous écoute…",
    assistantProcessing: "Traitement…",
    assistantClose: "Fermer",
    assistantContextNeeded: "Ouvrez d'abord un contenu pour cette commande.",
    assistantUnknown: "Commande non reconnue",
    wakeWordLabel: "Mot de déclenchement",
    wakeWordDesc: "Dites ce mot pour activer l'assistant vocal automatiquement.",
    wakeWordCustom: "Mot personnalisé…",
    wakeWordSave: "Enregistrer",
    wakeWordSaved: "Mot de déclenchement enregistré : {{word}}",
    wakeWordTooShort: "Le mot doit comporter au moins 2 caractères.",
    wakeWordActive: "Mot actif : « {{word}} »",
    transcriptionCopied: "Transcription copiée !",
    processingError: "Erreur de traitement",
    unsupportedTitle: "Saisie vocale indisponible",
    unsupportedHint:
      "Votre navigateur ne prend pas en charge la reconnaissance vocale. Essayez Chrome sur Android ou un navigateur de bureau (Chrome / Edge). La saisie vocale n'est pas disponible sur iPhone/iPad.",
    unsupportedClose: "Fermer",
    cmdNavigate: "J'ouvre la page demandée.",
    cmdGenerating: "Je lance la génération sur : {{subject}}.",
    cmdGenerateOpen: "J'ouvre la génération de contenu.",
    cmdNoContent: "Aucun contenu à traiter pour l'instant. Demandez-moi d'en générer un.",
    cmdCopied: "Contenu copié dans le presse-papiers.",
    cmdStopped: "Lecture arrêtée.",
    cmdOpenForEdit: "J'ouvre le contenu pour appliquer votre modification.",
    cmdNotUnderstood: "Désolé, je n'ai pas compris. Pouvez-vous reformuler ?",
    cmdScope:
      "Je suis IQ Assistant, votre assistant vocal. Je peux générer, lire, copier, améliorer, traduire ou exporter du contenu. Que souhaitez-vous créer ?",
  },
  // History page
  history: {
    title: "Historique",
    exportBulk: "Export ZIP",
    exportZipDone: "ZIP téléchargé !",
    exportZipEmpty: "Aucun contenu visible à exporter.",
    tag: "Tags",
    tagAdd: "Ajouter un tag…",
    tagSaved: "Tags mis à jour",
    tagFilterLabel: "Filtrer par tag",
    tagFilterPlaceholder: "Tag…",
    tagClearFilter: "Effacer le filtre tag",
    searchPlaceholder: "Rechercher dans tous mes contenus… ⌘K",
    allTypes: "Tous types",
    favorites: "Favoris",
    list: "Liste",
    grid: "Grille",
    colContent: "Contenu",
    colType: "Type",
    colTone: "Ton",
    colLang: "Lang",
    colTokens: "Tokens",
    colWhen: "Quand",
    noResultTitle: "Aucun résultat",
    noFavoriteTitle: "Aucun favori",
    emptyTitle: "Bibliothèque vide",
    noResultDesc: 'Aucun contenu ne correspond à "{{q}}". Essayez d\'autres mots-clés.',
    noFavoriteDesc: "Marquez vos contenus préférés avec ★ pour les retrouver ici.",
    emptyDesc:
      "Votre bibliothèque est vide. Générez votre premier contenu pour le voir apparaître ici.",
    generateFirst: "Générer mon premier contenu",
    resetFilters: "Réinitialiser les filtres",
    totalContents: "{{n}} contenus au total",
    deleteSuccess: "Contenu archivé",
    copied: "Copié !",
    exportFormatDone: "Export {{format}} téléchargé !",
    exportFormatError: "Erreur export",
  },
  // Profile page
  profile: {
    title: "Profil & préférences vocales",
    subtitle: "Configurez votre identité, votre voix et votre micro.",
    accountSection: "Compte",
    labelName: "Nom",
    labelEmail: "Email",
    labelBio: "Bio courte",
    bioPh: "Copywriter & consultant",
    labelLang: "Langue interface",
    saveBtn: "Sauvegarder",
    savingBtn: "Sauvegarde…",
    logoutBtn: "Se déconnecter",
    saveSuccess: "Profil mis à jour",
    saveError: "Impossible de sauvegarder.",
    voiceSection: "Voix de l'IQ Assistant",
    voiceDesc:
      "Choisissez la voix qui répondra à vos questions. Cliquez pour entendre un échantillon.",
    stopPreview: "Arrêter",
    listenPreview: "Écouter un aperçu",
    speedLabel: "Vitesse de lecture",
    autoPlayLabel: "Lecture auto des réponses",
    autoPlayDesc: "L'assistant lit ses réponses à voix haute.",
    micSection: "Microphone & reconnaissance",
    micLangLabel: "Langue de reconnaissance",
    micEngineLabel: "Moteur principal",
    micSensLabel: "Sensibilité du micro",
    micMoreSensitive: "Plus sensible",
    micLiveTest: "Test live",
    micMoreTolerant: "Plus tolérant au bruit",
    testMicBtn: "Tester mon micro",
    testMicSample: "Bonjour, ceci est un test…",
    subSection: "Abonnement",
    subFree: "Gratuit",
    subPro: "$9.99 / mois",
    subBusiness: "$29.99 / mois",
    stripePortal: "Portail Stripe",
    upgradePro: "Passer Pro",
    upgradeBusiness: "Passer Business",
    upgradeBtn: "Mettre à niveau",
    manageSub: "Gérer",
    editProfileTitle: "Modifier le profil",
    voiceSectionMobile: "Préférences vocales",
    voiceAssistantLabel: "Voix de l'assistant",
    listenBtn: "Écouter",
    testMicTitle: "Tester votre micro",
    micTestingStatus: "Niveau d'entrée détecté · OK",
    micTestIdle: "Cliquez pour tester",
    subAccountSection: "Compte & abonnement",
    topupCredits: "Recharger crédits",
    topupDesc: "$10 / 100 cr. · {{remaining}} restants",
    micLangSetting: "Langue micro",
    sensAuto: "Auto",
    sensHigh: "Haute",
    sensNormal: "Normale",
    sensLow: "Basse",
    voiceSaved: 'Voix "{{name}}" enregistrée',
  },
  // Templates page
  templates: {
    title: "Templates",
    createBtn: "Créer un template",
    countDesc: "{{n}} templates disponibles · partagez les vôtres avec votre équipe.",
    searchPh: "Rechercher un template…",
    myTemplates: "Mes templates",
    catAll: "Tous",
    catMarketing: "Marketing",
    catSocial: "Social",
    catBusiness: "Business",
    catCreative: "Créatif",
    upgradePlanNotice: "La création de templates personnalisés est disponible à partir du plan",
    noDescr: "Aucune description",
    usageCount: "↗ {{n}} util.",
    useBtn: "Utiliser →",
    deleteTitle: "Supprimer",
    noResultTitle: "Aucun template trouvé",
    noResultDesc: 'Aucun template correspond à "{{q}}". Essayez un autre terme.',
    emptyCatTitle: "Aucun template disponible",
    emptyCatDesc: 'Aucun template dans la catégorie "{{cat}}".',
    emptyDesc: "Les templates seront disponibles après initialisation de la base de données.",
    seeAll: "Voir tous les templates",
    createFirst: "Créer mon premier template",
    loaded: 'Template "{{name}}" chargé !',
    deleted: "Template supprimé",
    // Create modal
    modalTitle: "Nouveau template",
    labelName: "Nom *",
    namePh: "Ex: Post LinkedIn viral",
    labelDesc: "Description",
    descPh: "Description courte",
    labelType: "Type",
    labelCategory: "Catégorie",
    catSocialOption: "Réseaux sociaux",
    labelPrompt: "Prompt template *",
    promptHint: "(utilisez {{variable}} pour les variables)",
    promptPh: "Génère un post LinkedIn sur {{sujet}} avec un ton {{ton}}.",
    makePublic: "Rendre ce template public",
    cancelBtn: "Annuler",
    createModalBtn: "Créer le template",
    creatingBtn: "Création…",
    createdSuccess: "Template créé !",
    createError: "Erreur lors de la création",
  },
  // Pricing page
  pricing: {
    eyebrow: "Tarifs simples",
    title: "Choisissez votre voix.",
    subtitle: "Mensuel ou annuel — 2 mois offerts. Annulation en un clic depuis le portail Stripe.",
    monthly: "Mensuel",
    annual: "Annuel · −20%",
    manageBtn: "Gérer mon abonnement",
    loadingBtn: "Chargement…",
    perMonthAnnual: "/mois (annuel)",
    perMonth: "/mois",
    currentPlan: "Plan actuel",
    payError: "Impossible d'ouvrir le paiement. Réessayez.",
    portalError: "Portail de facturation indisponible.",
    creditsALaCarte: "Crédits à la carte :",
    creditPrice: "$10 / 100 cr.",
    creditDesc: "1 crédit ≈ 350 mots générés.",
    // Plan content
    freeTag: "Pour découvrir",
    freeCta: "Commencer",
    proTag: "Le plus populaire",
    proCta: "Choisir Pro",
    businessTag: "Agences & équipes",
    businessCta: "Choisir Business",
  },
  // Auth page
  verifyEmail: {
    loadingTitle: "Vérification en cours…",
    loadingDesc: "Validation de votre adresse email.",
    successTitle: "Email vérifié !",
    successDesc: "Votre compte est actif. Bonne génération !",
    successCta: "Accéder à mon espace",
    errorTitle: "Lien invalide",
    errorDesc:
      "Ce lien est invalide ou a expiré (24h). Demandez un nouveau lien depuis la connexion.",
    backLogin: "← Retour à la connexion",
  },
  resetPassword: {
    successTitle: "Mot de passe réinitialisé !",
    successDesc: "Redirection vers la connexion dans quelques secondes…",
    successCta: "Se connecter maintenant",
    title: "Nouveau mot de passe",
    subtitle: "Choisissez un mot de passe sécurisé pour votre compte.",
    labelNew: "Nouveau mot de passe",
    labelNewHint: "· min. 8 caractères",
    labelConfirm: "Confirmer le mot de passe",
    submit: "Réinitialiser mon mot de passe",
    submitting: "Réinitialisation…",
    backLogin: "← Retour à la connexion",
    invalidLink: "Lien invalide ou expiré",
    strengthWeak: "Faible",
    strengthOk: "Correct",
    strengthSolid: "Solide",
    strengthStrong: "Fort",
  },
  admin: {
    title: "Administration",
    subtitle: "Gestion des utilisateurs, statistiques et logs",
    tabUsers: "Utilisateurs",
    tabLogs: "Logs",
    loading: "Chargement…",
    roleUpdated: "Rôle mis à jour",
    error: "Erreur",
    banned: "Utilisateur banni",
    bannedDesc: "Sessions révoquées, rôle réinitialisé à Free.",
    statUsers: "Utilisateurs totaux",
    statUsersSub: "+{{count}} cette semaine",
    statContents: "Contenus générés",
    statCredits: "Crédits consommés",
    statCreditsSub: "total cumulé",
    statPlans: "Répartition plans",
    statQuality: "Score qualité moyen",
    statQualitySub: "{{count}} contenus évalués",
    searchPh: "Rechercher par nom ou email...",
    allRoles: "Tous les rôles",
    colUser: "Utilisateur",
    colRole: "Rôle",
    colCredits: "Crédits",
    colJoined: "Inscrit le",
    colActions: "Actions",
    noUsers: "Aucun utilisateur trouvé",
    emailUnverified: "Email non vérifié",
    ban: "Bannir",
    pagination: "{{total}} utilisateurs · Page {{page}}/{{pages}}",
    banTitle: "Bannir cet utilisateur ?",
    banIrreversible: "Cette action est irréversible depuis l'UI.",
    banWarning:
      "Toutes les sessions seront révoquées, le rôle réinitialisé à Free et les crédits remis à zéro.",
    cancel: "Annuler",
    banConfirm: "Confirmer le ban",
    liveTitle: "Activité en direct",
    liveWaiting: "En attente d'événements (inscriptions, générations)…",
    liveSignup: "Inscription",
    liveGeneration: "Génération",
  },
  logs: {
    title: "Journal des logs",
    meta: "{{total}} entrées · auto-suppression après 90 jours",
    loading: "Chargement…",
    autoOn: "Auto ON",
    autoOff: "Auto OFF",
    refresh: "Rafraîchir",
    clear: "Vider",
    clearConfirm: "Supprimer tous les logs ?",
    cleared: "{{count}} logs supprimés",
    allLevels: "Tous niveaux",
    levelInfo: "Info",
    levelWarn: "Avertissement",
    levelWarnShort: "Avert.",
    levelError: "Erreur",
    allCats: "Toutes catégories",
    catAuth: "Auth",
    catGeneration: "Génération",
    catCredits: "Crédits",
    catSystem: "Système",
    catAdmin: "Admin",
    colTime: "Horodatage",
    colLevel: "Niveau",
    colCategory: "Catégorie",
    colAction: "Action",
    colMessage: "Message",
    colUser: "Utilisateur",
    colIp: "IP",
    noLogs: "Aucun log trouvé",
    pagination: "Page {{page}} / {{pages}} · {{total}} entrées",
  },
  auth: {
    loginTitle: "Bon retour.",
    loginSubtitle: "Connectez-vous pour reprendre vos brouillons.",
    continueGoogle: "Continuer avec Google",
    or: "OU",
    orEmail: "OU PAR EMAIL",
    labelEmail: "Email",
    emailPh: "vous@exemple.com",
    labelPassword: "Mot de passe",
    forgotPwd: "Oublié ?",
    loginBtn: "Se connecter",
    loggingInBtn: "Connexion…",
    loginFailed: "Connexion échouée",
    loginError: "Erreur de connexion",
    noAccount: "Pas encore de compte ?",
    createAccount: "Créer un compte",
    registerTitle: "Créez votre compte",
    registerSubtitle: "50 crédits offerts. Sans CB.",
    labelFullName: "Nom complet",
    fullNamePh: "Abdel Wariss Osseni",
    labelPasswordStrength: "Mot de passe",
    passwordHint: "· min. 8 caractères",
    pwdWeak: "Faible",
    pwdOk: "Correct",
    pwdSolid: "Solide",
    pwdStrong: "Fort",
    labelYouAre: "Vous êtes…",
    contentCreator: "Créateur de contenu",
    agency: "Agence de communication",
    sme: "PME / Startup",
    freelance: "Freelance",
    ngo: "ONG / Association",
    acceptTerms: "J'accepte les conditions et la politique de confidentialité.",
    createBtn: "Créer mon compte",
    creatingBtn: "Création…",
    registerFailed: "Inscription échouée",
    registerError: "Erreur d'inscription",
    alreadyAccount: "Déjà inscrit ?",
    signIn: "Se connecter",
    forgotTitle: "Mot de passe oublié",
    forgotSubtitle: "Entrez votre email pour recevoir un lien de réinitialisation.",
    sendLinkBtn: "Envoyer le lien",
    sendingBtn: "Envoi…",
    sendError: "Impossible d'envoyer l'email.",
    backToLogin: "← Retour à la connexion",
    emailSentStep: "Étape 2 / 3",
    emailSentTitle: "On vous a envoyé un lien.",
    emailSentDesc: "Email envoyé à {{email}}. Le lien expire dans 1h.",
    notReceived: "Pas reçu ?",
    spamCheck: "Vérifiez votre dossier spam",
    wait30s: "Patientez ~30 secondes",
    resendBelow: "Renvoyez le lien ci-dessous",
    resendBtn: "Renvoyer",
    resendTimer: "Renvoyer · 0:{{s}}",
    backToLoginBtn: "Retour au login",
    emailResent: "Email renvoyé !",
    resendError: "Erreur",
    testimonialLabel: "★ Témoignage",
    todayLabel: "Aujourd'hui sur CONTENT.IQ",
  },
  // Common
  common: {
    loading: "Chargement…",
    error: "Une erreur est survenue",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    close: "Fermer",
    back: "Retour",
    copyright: "© 2026 CODEXA Solutions — Tous droits réservés",
  },
  // Landing page
  landing: {
    // Nav
    navProduct: "Produit",
    navVoice: "Voix",
    navTemplates: "Templates",
    navPricing: "Tarifs",
    navUseCases: "Cas d'usage",
    navLogin: "Connexion",
    navCta: "Essai gratuit",
    // Hero
    heroPill: "Nouveau · IQ Assistant à la voix",
    heroTitle: "Écrivez à voix haute.",
    heroTitleAccent: "Pas au clavier.",
    heroDesc:
      "CONTENT.IQ génère articles, posts, emails et bien plus — en streaming temps réel via Claude. Dictez vos consignes, naviguez à la voix, conversez avec l'IQ Assistant. Sans toucher au clavier.",
    heroCtaPrimary: "Démarrer · 10 cr. offerts",
    heroCtaDemo: "Démo vocale · 0:42",
    trustReviews: "★★★★★ 4.9 · 82 avis Product Hunt",
    trustNoCc: "Sans CB",
    // Built for
    builtForTitle: "Pensé pour",
    builtForCreators: "Créateurs de contenu",
    builtForAgencies: "Agences",
    builtForSME: "PME",
    builtForNGOs: "NGOs",
    builtForFreelance: "Freelances",
    builtForMicro: "Microfinances",
    // Pillars
    pillarsTitle: "Trois manières de produire.",
    pillarsTitleAccent: "Une seule app.",
    p0tag: "01 · GENERATE",
    p0title: "Génération streaming",
    p0body:
      "Token par token via SSE. Vous voyez le contenu apparaître en direct, comme une vraie conversation.",
    p0meta: "Claude · 12 formats",
    p1tag: "02 · ASSIST",
    p1title: "IQ Assistant context-aware",
    p1body:
      "Il connaît votre page, vos crédits, votre brouillon. Il améliore, suggère, brainstorme avec vous.",
    p1meta: "20 tours de contexte",
    p2tag: "03 · VOICE",
    p2title: "Tout à la voix",
    p2body:
      "Dictez vos consignes, naviguez à la voix, écoutez les réponses. ElevenLabs + Whisper + Web Speech.",
    p2meta: "25 commandes natives",
    // Voice section
    voiceTag: "03 · VOICE",
    voiceTitle: "Votre voix.",
    voiceTitleAccent: "Votre outil.",
    voiceDesc:
      "Dictez vos briefs, naviguez entre les pages, déclenchez des générations — sans jamais toucher au clavier. ElevenLabs pour la synthèse, Whisper pour la transcription, Web Speech pour la réactivité instantanée.",
    voiceFeat0label: "Transcription Whisper + Web Speech",
    voiceFeat0desc: "Précision professionnelle · latence zéro",
    voiceFeat1label: "Synthèse vocale ElevenLabs",
    voiceFeat1desc: "Écoutez les réponses de l'IQ Assistant en audio",
    voiceFeat2label: "25 commandes natives",
    voiceFeat2desc: "Générer, naviguer, exporter — tout à la voix",
    voiceCmdsTitle: "Commandes vocales en direct",
    // CTA band
    ctaTitle: "Commencez gratuitement.",
    ctaTitleAccent: "Aujourd'hui.",
    ctaDesc: "10 crédits offerts · Sans carte bancaire · Annulable à tout moment",
    ctaBtn: "Créer mon compte gratuit",
    // Footer
    footerLogin: "Connexion",
    footerPrivacy: "Confidentialité",
    footerTerms: "Conditions",
    footerApi: "API",
    footerApiSoon: "Bientôt",
    // Demo modal
    demoPaused: "En pause",
    demoPlaying: "En lecture",
    demoCta: "Essayer gratuitement",
  },
  // 404 page
  notFound: {
    title: "Page introuvable",
    desc: "Cette page n'existe pas ou a été déplacée. Retournez à votre espace de travail.",
    backDashboard: "Retour au Dashboard",
    generate: "Générer du contenu",
    backHome: "Retour à l'accueil",
    login: "Se connecter",
  },
  notify: {
    subscriptionActive: "Abonnement activé — vos crédits ont été mis à jour.",
    paymentFailed: "Échec du paiement. Régularisez sous 3 jours pour éviter le passage en Free.",
  },
} as const;

export default fr;
